import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import api from '../../lib/api';
import { Loader2 } from 'lucide-react';

function SlugRedirect() {
  var params = useParams();
  var slug = params.slug;
  var state = useState({ serverId: null, loading: true, error: false });
  var serverId = state[0].serverId;
  var loading = state[0].loading;
  var error = state[0].error;
  var setState = state[1];

  useEffect(function() {
    var fetchServerId = async function() {
      try {
        var response = await api.getServerBySlug(slug);
        setState({ serverId: response.data.server_id, loading: false, error: false });
      } catch (err) {
        setState({ serverId: null, loading: false, error: true });
      }
    };
    fetchServerId();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <Loader2 className="h-8 w-8 animate-spin text-teal-400" />
      </div>
    );
  }

  if (error || !serverId) {
    return <Navigate to="/search" replace />;
  }

  return <Navigate to={'/servers/' + serverId} replace />;
}

export default SlugRedirect;
